import { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, CircularProgress } from "@mui/material";
import { deleteAdvertisingBanner } from "../../../services/Admin/AdvertisingBannersApi";

const DeleteAdvertisingBannerDialog = ({ open, onClose, onSuccess, banner }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleDelete = async () => {
    if (!banner?.id) return;
    setError("");
    setLoading(true);
    try {
      const res = await deleteAdvertisingBanner(banner.id);
      if (res?.success) {
        onSuccess?.();
      } else {
        setError(res?.message || "فشل حذف البانر");
      }
    } catch (err) {
      setError(err?.message || "حدث خطأ أثناء الحذف");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>تأكيد حذف البانر</DialogTitle>
      <DialogContent>
        <Typography>
          هل أنت متأكد من حذف البانر <strong>{banner?.title_ar || banner?.title_en || `#${banner?.id}`}</strong>؟
        </Typography>
        {error && <Typography color="error" sx={{ mt: 1 }}>{error}</Typography>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>إلغاء</Button>
        <Button variant="contained" color="error" onClick={handleDelete} disabled={loading}>
          {loading ? <CircularProgress size={20} /> : "حذف"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAdvertisingBannerDialog;
